import { Button, Modal, ModalInner } from 'components';

interface ModalProps {
  message: string;
  isOpen: boolean;  // 모달의 열림 상태
  onCancel: () => void;  
}

const ValidationModal = ({message, isOpen, onCancel }: ModalProps) => {
  return (
    <Modal isOpened={isOpen}>
      <ModalInner className="md:w-[400px] " title="Confirmation" onClickClose={onCancel}>
        <p className="p-6 =text-body1 bg-bg-transparent_gray_light">
        <p>{message}</p>
        </p>

      </ModalInner>
    </Modal>
  );
};

export default ValidationModal;